import { Flex } from "@rpi/openapi-core";
import React from "react";

/** Lays fields side by side, wrapping to a single column on narrow viewports. */
export const FieldRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Flex.Row gap={24} fullWidth sx={{ flexWrap: "wrap" }}>
    {children}
  </Flex.Row>
);
